/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Sales_Src_3_DetailInputs */

const en_wb_sales_src_3_detail = /** @type {(inputs: Wb_Sales_Src_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuesday · 11:00 available`)
};

const lv_wb_sales_src_3_detail = /** @type {(inputs: Wb_Sales_Src_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otrdien · 11:00 brīvs`)
};

/**
* | output |
* | --- |
* | "Tuesday · 11:00 available" |
*
* @param {Wb_Sales_Src_3_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_sales_src_3_detail = /** @type {((inputs?: Wb_Sales_Src_3_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Sales_Src_3_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_sales_src_3_detail(inputs)
	return en_wb_sales_src_3_detail(inputs)
});